<template>
    <Disclosure
        v-slot="{ open }"
        :default-open="true"
        as="div"
        class="top-pages"
    >
        <DisclosureButton class="top-pages__item">
            <span>{{ $page.props.settings.translations.topPages.title }}</span>

            <svg
                :class="open ? '' : 'top-pages__item-icon--closed'"
                xmlns="http://www.w3.org/2000/svg"
                class="top-pages__item-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </DisclosureButton>

        <Transition
            enter-active-class="top-pages__transition top-pages__transition--active"
            enter-from-class="top-pages__transition--enter-from"
            enter-to-class="top-pages__transition--enter-to"
            leave-active-class="top-pages__transition top-pages__transition--leave-active"
            leave-from-class="top-pages__transition--leave-from"
            leave-to-class="top-pages__transition--leave-to"
        >
            <DisclosurePanel class="top-pages__panel">
                <ul class="top-pages__list">
                    <li
                        v-for="page in pages"
                        :key="page.url"
                        class="top-pages__list-item"
                    >
                        <a
                            class="top-pages__list-item-link"
                            :href="page.url"
                        >
                            {{ page.title?.replace(/^_/, '') }}
                        </a>
                    </li>
                </ul>
            </DisclosurePanel>
        </Transition>
    </Disclosure>
</template>

<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';

defineProps({
    pages: {
        type: Array,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use 'watson-theme-top-pages';
</style>
